import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import _ from 'lodash';
import { addGLCode, updateGLCode } from '../../services/glCodeServices';
import { isNTMSUSer } from '../../utils/roleUtils';
import { fetchAccountType } from '../../services/accountTypeServices';
import ModalRender from '../Commons/ModalRender';
import { useDispatch, useSelector } from 'react-redux';
import { addGLCodeData, setGLCodeData } from '../../redux/glCode/glCodeReducer';
import FormTabs from '../Commons/Layouts/FormTabs';
import PrimaryDetails from './PrimaryDetails';
import { setFormPendingCompletion, setFormPendingFunction, setNotificationData } from "../../redux/global/globalReducer";
import { updateFormDataOnExit } from '../../utils/formUtils';

function GLCodeForm({
  isFormEdit = false,
  selectedGLCode = {},
  isFormHidden,
  toggleFormDisplay,
  setIsFormDirty,
  modal,
  setModal,
  toggle,
  focusOnOpenOrCloseButton
}) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    setFocus,
    control,
    formState
  } = useForm();
  const { dirtyFields, errors, isDirty } = formState;
  const userType = useSelector((state) => state.auth.user.userType);
  const accountId = useSelector((state) => state.auth.user.accountId);
  const accountState = useSelector((state) => state.account.selectedAccount);
  const isInitialRender = useRef(true);

  // form values
  setValue('glCodeId', 0);
  // setValue('accountId', accountId);

  // useStates
  const [accountTypeList, setAccountTypeList] = useState([])

  // useEffects
  useEffect(() => {
    clearErrors();
    fillAccountType();
  }, []);

  useEffect(() => {
    clearErrors();
    reset();
    if (!isFormHidden) {
      setTimeout(() => {
        setFocus("glCodeName");
      }, 50);
    }
  }, [isFormHidden]);

  useEffect(() => {
    const updateForm = async () => {
      await updateFormDataOnExit(
        dispatch,
        !_.isEmpty(dirtyFields),
        setIsFormDirty,
        isFormEdit,
        _.isEmpty(errors),
        handleSubmit,
        onSubmit
      )
    }

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    updateForm();
  }, [formState])

  const fillAccountType = async () => {
    const response = await fetchAccountType();
    setAccountTypeList(response);
  }

  const onSubmit = async (payload, keepAlive = false) => {
    let response = null;
    if (isFormEdit) {
      _.set(payload, 'glCodeId', selectedGLCode.glCodeId);
      _.set(payload, 'accountId', accountId);
      response = await updateGLCode(payload, keepAlive);

      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } GL code.`,
        })
      );
    } else {
      _.set(payload, 'glCodeId', 0);
      if (isNTMSUSer(userType)) {
        _.set(payload, 'accountId', accountState.accountId != null ? accountState.accountId : accountId);
      } else {
        _.set(payload, 'accountId', accountId);
      }
      response = await addGLCode(payload, keepAlive);

      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } GL code.`,
        })
      );
    }

    if (response.ok) {
      const glCodeData = await response.json();
      dispatch(isFormEdit ? setGLCodeData(glCodeData) : addGLCodeData(glCodeData));

      if (isDirty) {
        setModal(false);
      }
      setIsFormDirty(false);
      dispatch(setFormPendingCompletion(false));
      reset({}, {keepValues: true});
      return true;
    }
    return false;
  }

  const tabItems = [
    {
      label: "Primary Details",
      key: 0,
      forceRender: true,
      children: (
        <div className="content-section-container color-6-section">
          <div className="row form-container" id="primary-details-form">
            <PrimaryDetails
              isFormEdit={isFormEdit}
              isFormHidden={isFormHidden}
              setIsFormDirty={setIsFormDirty}
              selectedGLCode={selectedGLCode}
              control={control}
              register={register}
              errors={errors}
              setValue={setValue}
              reset={reset}
              accountTypeList={accountTypeList}
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <form id="gl-code-form" onSubmit={handleSubmit(async (payload) => onSubmit(payload, false))}>
        <FormTabs
          items={tabItems}
          tabClassName="color-6"
          isFormHidden={isFormHidden}
        />

        <div className="row mt-5">
          <div className="col-12">
            <div className="d-flex flex-row align-items-center">
              <button className={`ms-auto btn btn-primary`} type="submit">
                Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default GLCodeForm
